exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pace {\r\n  -webkit-pointer-events: none;\r\n  pointer-events: none;\r\n\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n      user-select: none;\r\n}\r\n\r\n.pace-inactive {\r\n  display: none;\r\n}\r\n\r\n.pace .pace-progress {\r\n  background: #ff6275;\r\n  position: fixed;\r\n  z-index: 2000;\r\n  top: 0;\r\n  right: 100%;\r\n  width: 100%;\r\n  height: 3px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!E:/proj/news12/zb-n12/scadmin/client/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!E:/proj/news12/zb-n12/scadmin/client/src/assets/vendors/css/extensions/pace.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/vendors/css/extensions/pace.css
// module chunks = styles